<template>
  <b-container fluid>
    <div class="overflow-auto" v-if="!loader">


  <!--      <b-form-group class="mb-0 filter">
          <b-input-group size="sm">
            <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>  -->


      <b-table
        id="my-table"
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :striped="true"
        :bordered="true"
        :hover="false"
        :dark="false"
        small
        :filter="filter"
      >
        <!-- <template slot="notify" slot-scope="row">
          <div v-if="row.item.status == 'open'">
            <button class="table-btn" size="sm" @click="sendNotification(row.item)" >
              <span>{{ row.item.notify }}</span>
            </button>
          </div>

          <span v-else>{{ row.item.notify }}</span>
        </template> -->

        <template slot="options" slot-scope="row">

          <button v-if="hasDeleteButton" class="table-btn" size="sm" @click="deleteTag(row.item)">
              <span>Delete</span>
          </button>

          <!-- <button v-if="hasDeleteButton" class="table-btn" size="sm" @click="editTag(row.item)">
              <span>Edit</span>
          </button> -->

        </template>

      </b-table>

<!--      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
        align="right"
      ></b-pagination> -->

      <!-- <p class="mt-3">page {{ currentPage }} of 20 </p> -->
    </div>

    <div v-else>
      <Loader/>
    </div>

  </b-container>
</template>

<script>
var moment = require('moment');
import Loader from "../../../components/Loader"
import firebase from 'firebase'
import axios from 'axios'
export default {
  components: {
    Loader,
  },
  props: {
    items: Array,
    fields: Array,
    hasDeleteButton: {
      default: false,
      type: Boolean
    },
},
  data() {
    return {
      perPage: 20,
      currentPage: 1,
      loader: false,
      deleteTagApi: 'https://us-central1-readytextme.cloudfunctions.net/deleteTags',
      filter: null,
      business: ''
    }
  },
  watch: {

  },
  async created() {
        const userDoc = await firebase.firestore().collection('users').doc(firebase.auth().currentUser.uid).onSnapshot(async(doc) => {
            this.business = doc.data().business;
        });
  },
  methods: {

    async deleteTag (item) {
      // method to delete tag from tag table
      console.log('deleting tag');

      const obj = {
        'business': this.business,
        'tag': item.tag,
      }

    //   console.log(obj);
    // sending api request to delete tag from db
      try {
        this.loader = true;
        await axios.post(
        this.deleteTagApi,
        obj,
        {
          headers: {
            'Content-Type': 'application/json'
          },
        })
        this.loader = false;
        console.log('tag deleted');
      } catch (error) {
          console.log(error);
          this.loader = false;
      }

    },

    async editTag (item) {
      console.log('editing tag');

    //   const obj = {
    //     'business': item.business,
    //     'phone': item.phone_number,
    //     'startTime': item.startTime
    //   }

    //   // console.log(obj);

    //   try {
    //     this.loader = true;
    //     await axios.post(
    //     this.deleteOrderApi,
    //     obj,
    //     {
    //       headers: {
    //         'Content-Type': 'application/json'
    //       },
    //     })
    //     this.loader = false;
    //     console.log('order deleted');
    //   } catch (error) {
    //       console.log(error);
    //       this.loader = false;
    //   }

    },
  },
  computed: {
    rows() {
      return this.items.length
    }
  }
}
</script>

<style scoped>
.table-btn {
    border: 0px;
    background-color: #ffffff00;
    color: #DA2a2a;

    /* color: #2f8ce2; */
}

.table-btn:hover {
    text-decoration: underline;
}

.edit-order {
  position: absolute;
  width: 400px;
  height: 330px;
  z-index: 100;
  padding-top: 70px;
  /* top: 0; */
  bottom: 30%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #e7e7e7;
  border-radius: 5px;
  transition: all 0.8s ease;
}

.filter {
  /* position: absolute; */
  /* left: 0; */
  width: 300px;
  padding-bottom: 20px;
}
</style>
